import { useMemo, useRef } from "react";

import { Switch } from "@/components/shared/switch";

let idCounter = 0;

interface SwitchInputProps {
  label: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  "data-testid"?: string;
}

export function SwitchInput({
  label,
  checked,
  defaultChecked,
  onChange,
  disabled,
  "data-testid": testId,
}: SwitchInputProps) {
  const idRef = useRef<string | null>(null);

  const id = useMemo(() => {
    if (idRef.current === null) {
      idRef.current = `switch-input-${++idCounter}`;
    }
    return idRef.current;
  }, []);

  return (
    <div className="flex items-center justify-between">
      <label htmlFor={id} className="text-sm">
        {label}
      </label>

      <Switch
        id={id}
        label={label}
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={onChange}
        disabled={disabled}
        data-testid={testId}
      />
    </div>
  );
}
